export const EDITING = 'EDITING';
export const READ_ONLY = 'READ_ONLY';
export const PUBLIC = 'PUBLIC';
export const LOCAL = 'LOCAL';
